import { defineStore } from 'pinia'

export interface typeMediaItem  {
  id: number,
  idType: number,
  title: string,
  desc: string,
  youtubeCode: string,
  thumb: string,
  images: string[]
}

export const useMainStore = defineStore('mainStore', {
  state: () => ({
    menu: [
      {id: 'commercials', text: 'Рекламные ролики'},
      {id: 'tv', text: 'Оформление ТВ&nbspтрансляций'},
      {id: 'presentations', text: 'Презентации и музыкальные клипы'}
    ],
    media: [] as typeMediaItem[],
    phone: '+7 962 587 4910',
    loaded: false,
    showMobile: false,
    maxWidth: 768
  }),
  actions: {
    getMedia( category: string | undefined): typeMediaItem[] {
      let id = 0
      switch (category) {
        case 'commercials':
          id = 1
          break
        case 'tv':
          id = 2
          break
        case 'presentations':
          id = 3
      }
      if (id === 0) { return this.media }
      return this.media.filter((el) => el.idType === id)
    },
    getProject ( id: number): typeMediaItem | undefined {
      return this.media.find(el => el.id === id)
    },
    async loadMedia() {
      // Загрузка JSON массива из файла
      await fetch('/data.json')
      .then((response) => response.json())
      .then((data) => {
        this.media = data
        this.loaded = true
      })
    }, 
    async convertPHP() {
      // Конвертируем из PHP массива 
      const res = await fetch('/php/convert.php', {
        method: 'POST',
      })
      const tempArr: typeMediaItem[] = []
      const data = await res.json()
      let i = 0
      data.forEach((element: string[])  => {
        const mediaItem: typeMediaItem = {
          id: i++,
          idType: Number(element[0]),
          title: element[1],
          desc: element[2],
          youtubeCode: element[3],
          thumb: element[4],
          images: element.splice(5)
        }
        tempArr.push(mediaItem)
      })
      this.media = tempArr
    }
  },
  getters: {
  },
})
